export const selectSupplierServicesBySupplier = (state, supplierId) =>
  state.supplierServices && state.supplierServices.servicesBySupplier
    ? state.supplierServices.servicesBySupplier[supplierId] || []
    : [];

export const selectSupplierServicesLoading = (state) =>
  state.supplierServices ? state.supplierServices.loading : 'idle';

export const selectSupplierServicesError = (state) =>
  state.supplierServices ? state.supplierServices.error : null;
